export default "__VITE_ASSET__CZCyh0Rp__"